<template>
  <el-dialog
      :visible.sync="visible"
      title="批量收款"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="80%"
      :append-to-body="true"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="formRules"
        label-width="100px"
    >
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item prop="accountId" label="收款公司：">
            <el-select v-model="dataForm.accountId" style="width: 100%;" placeholder="请选择收款账户" size="mini"
                       @change="accountBankChanged">
              <el-option v-for="item in accountBankList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="operateDate" label="收款日期：">
            <el-date-picker type="date" placeholder="请选择收款日期" style="width: 100%;" v-model="dataForm.operateDate"
                            size="mini"
                            value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="bankName" label="收款行：" label-width="80px">
            <el-input v-model="dataForm.bankName" size="mini" clearable type="text"
                      placeholder="请输入收款行"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="accountNo" label="收款账号：">
            <el-input v-model="dataForm.accountNo" size="mini" clearable type="text"
                      placeholder="请输入收款账号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item label="收款金额：">
            <el-input v-model="totalAmount" size="mini" clearable type="text"
                      placeholder="请输入收款金额" @change="totalAmountChanged"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="currency" label="货币：">
            <currency v-model="dataForm.currency"></currency>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <vxe-table
        border
        show-footer
        show-overflow
        ref="xTable"
        :data="dataList"
        max-height="500"
        :ref="tableConfig.tableName"
        :footer-method="tableFooter"
        :edit-rules="validRules"
        align="center"
        :edit-config="{trigger: 'manual', mode: 'row'}">
      <vxe-column type="seq" title="行号" width="50"></vxe-column>
      <vxe-column field="receiptCode" title="进出口发票号">
      </vxe-column>
      <vxe-column field="customerName" title="客户">
      </vxe-column>
      <vxe-column field="currency" title="货币" width="80">
      </vxe-column>
      <vxe-column field="totalAmount" width="140" title="总应收">
      </vxe-column>
      <vxe-column field="receiveAmount" width="140" title="总已收">
      </vxe-column>
      <vxe-column field="amount" title="收款金额" width="140">
        <template #default="{ row }">
          <vxe-input v-model="row.amount" placeholder="请输入收款金额" size="mini"
                     @input="updateFooterEvent"></vxe-input>
        </template>
      </vxe-column>
      <vxe-column field="remark" title="备注">
        <template #default="{ row }">
          <vxe-input v-model="row.remark" placeholder="请输入备注" size="mini"></vxe-input>
        </template>
      </vxe-column>
    </vxe-table>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import VxeTable from '@/mixins/vxe-table'
import CommonDrop from '@/components/CommonDrop'
import { isMoney } from '@/utils/validate'
import moment from 'moment'
import BigNumber from 'bignumber.js'

export default {
  name: 'batch-save-dialog',
  mixins: [VxeTable],
  components: { CommonDrop },
  data () {
    const moneyValid = ({ cellValue }) => {
      // 模拟服务端校验
      return new Promise((resolve, reject) => {
        if (!isMoney(cellValue)) {
          reject(new Error('请输入正确金额'))
        } else {
          resolve()
        }
      })
    }
    return {
      totalAmount: 0,
      tableConfig: {
        autoHeight: false,
        footerColumn: ['totalAmount', 'receiveAmount', 'amount']
      },
      accountBankList: [],
      dataForm: {},
      dataList: [],
      visible: false,
      validRules: {
        amount: [
          { required: true, message: '请填写收款金额' },
          { validator: moneyValid }
        ]
      },
      formRules: {
        accountId: [
          { required: true, message: '请选择收款户头' }
        ],
        operateDate: [
          { required: true, message: '请填写收款日期' }
        ],
        bankName: [
          { required: true, message: '请填写收款行' }
        ],
        accountNo: [
          { required: true, message: '请填写收款帐号' }
        ],
      }
    }
  },
  methods: {
    totalAmountChanged (e) {
      //剩余金额
      let surplus = new BigNumber(e)
      if (surplus.isNaN() || !this.dataList || this.dataList.length === 0) {
        return
      }
      for (let i = 0; i < this.dataList.length; i++) {
        let row = this.dataList[i]
        if (surplus.isLessThanOrEqualTo(0)) {
          row.amount = 0
          break
        }
        if (surplus.isGreaterThanOrEqualTo(row.totalAmount)) {
          if(i===this.dataList.length-1){
            row.amount =surplus.toFixed(2)
          }else{
            row.amount = row.totalAmount
            surplus = surplus.minus(row.totalAmount)
          }
        } else {
          row.amount = surplus.abs().toFixed(2)
          surplus = new BigNumber(0)
        }
      }
      this.updateFooterEvent()
    },
    async getAccountList () {
      const { data: res } = await this.$http.get(`/trade/accountbank/list`)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.accountBankList = res.data
    },
    accountBankChanged (e) {
      let tmp = this.accountBankList.find(item => item.id === e)
      if (!tmp) {
        return
      }
      console.log('accountBankChanged', e)
      this.dataForm.accountNo = tmp.accountNo
      this.dataForm.bankName = tmp.bankName
    },
    reset () {
      this.dataForm = {
        accountId: '',
        operateDate: '',
        bankName: '',
        accountNo: '',
        currency: ''
      }
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields()
      }
    },
    updateFooterEvent () {
      const $table = this.$refs[this.tableConfig.tableName]
      $table.updateFooter()
    },
    init () {
      this.getAccountList()
      this.reset()
      let totalAmount = new BigNumber(0)
      if (this.dataList.length > 0) {
        this.dataForm.currency = this.dataList[0].currency
        this.dataList.forEach(row => {
          totalAmount = totalAmount.plus(row.amount)
        })
      }
      this.totalAmount = totalAmount.toFixed(2)
      this.dataForm.operateDate = moment().format('yyyy-MM-DD')
      this.visible = true
    },
    dataFormSubmitHandle () {
      this.$refs.dataForm.validate(valid => {
        if (!valid) {
          return
        }
        this.$refs[this.tableConfig.tableName].fullValidate(true, (errors) => {
          if (errors) {
            return
          }
          this.doSave()
        })
      })
    },
    cancel () {
      this.visible = false
    },
    async doSave () {
      let postForm = []
      this.dataList.forEach(row => {
        postForm.push({
          accountId: this.dataForm.accountId,
          accountNo: this.dataForm.accountNo,
          operateDate: this.dataForm.operateDate,
          bankName: this.dataForm.bankName,
          receiptCode: row.receiptCode,
          customerId: row.customerId,
          currency: row.currency,
          amount: row.amount,
          remark: row.remark
        })
      })
      const { data: res } = await this.$http.post(`/trade/receivelog/batch/save`, postForm)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.$message.success('保存成功')
      this.$emit('complete')
      this.cancel()
    }
  }
}
</script>

<style scoped>

</style>
